import React, { FC, memo, useState, useEffect, Dispatch } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'antd';
import { Button, SearchInput, Toast, Alerts } from '@kaleyra/emmy';
import { isEmpty } from 'lodash';
import { IStateType } from '../../../../store/models/root.interface';
import { getWabaIds } from '../../../../store/actions/whatsappLaunch.action';
import {
	addWabaIdObject,
	changeWabaIdDropdown,
	toggleWabaChangeModal,
} from '../../../../store/actions/wabaIdDropdown.action';
import upArrow from '../../../../../src/assets/arrow1.svg';
import downArrow from '../../../../../src/assets/arrow2.svg';
import whatsappIcon from '../../../../../src/assets/waSmall.svg';
import Styles from './index.module.scss';
import FacebookSDK from '../../../../components/facebookSDK';
import { submitEmbeddedSignup } from '../../../../store/actions/channels.action';
import { checkPrivileges, whatsappembededsignup } from '../../../../utils';

export type WabaIdProps = {};

const WabaId: FC<WabaIdProps> = () => {
	const { t } = useTranslation();

	const { isLaunchPage, wabaIdObject } = useSelector(
		(state: IStateType) => state.wabaId
	);

	const [showDropDown, setShowDropDown] = useState(false);
	const [wabaId, setWabaId] = useState<string>();
	const [wabaDetails, setwabaDetails] = useState<Record<string,any>>();
	const [wabaIdList, setWabaIdList] = useState<any>([]);
	const [searchedWabaIds, setSearchedWabaIds] = useState<any>([]);
	const [wabaDataEmpty, setWabaDataEmpty] = useState<boolean>(false);
	const profile = useSelector((state: IStateType) => state.profile);
	const { user_pod, cloud_api_service = 0 } = profile.fullProfile;

	const dispatch: Dispatch<any> = useDispatch();

	const WABA_ID = localStorage.getItem('WABA_ID');

	const initialRef: any = null;
	const ref = React.useRef(initialRef);
	const handleClickOutside = (event: any) => {
		if (ref.current && !ref.current.contains(event.target)) {
			setShowDropDown(false);
		}
	};
	useEffect(() => {
		document.addEventListener('click', handleClickOutside, true);
		return () => {
			document.removeEventListener('click', handleClickOutside, true);
		};
	}, []);

	useEffect(() => {
		callWabaIdAPI();
	}, []);

	const callWabaIdAPI = async () => {
		let response;
		let data;
		if (isEmpty(wabaIdObject)) {
			response = await getWabaIds();
			dispatch(addWabaIdObject(response));
			data = response?.data || {};
		} else {
			data = wabaIdObject?.data || {};
		}
		setWabaIdList(data);
		setSearchedWabaIds(data);
		if (!isEmpty(data)) {
			if (isEmpty(wabaId)) {
				if (WABA_ID) {
					setWabaId(WABA_ID);
					const wabaName = data?.filter(
						(item: any) => item.waba_id == WABA_ID
					);
					setwabaDetails(wabaName[0]);
					dispatch(changeWabaIdDropdown(WABA_ID, wabaName[0]?.version));
				} else {
					setWabaId(data[0].waba_id);
					setwabaDetails(data[0]);
					localStorage.setItem('WABA_ID', data[0]?.waba_id);
					dispatch(changeWabaIdDropdown(data[0]?.waba_id, data[0]?.version));
				}
			}
		} else {
			setWabaDataEmpty(true);
		}
	};

	const onSearch = (searchText: string) => {
		const searchedWabaId = wabaIdList.filter(
			(item: any) =>
				item.waba_id.includes(searchText) ||
				item.business_name
					.toLowerCase()
					.includes(searchText.toLowerCase())
		);
		setSearchedWabaIds(searchedWabaId);
	};

	const handleEmbeddedResponse = (
		payload: any,
		accessTokenFlag?: boolean
	) => {
		console.log(payload, accessTokenFlag, '>>>>>>.. from fb');
		if (accessTokenFlag && !isEmpty(payload)) {
			dispatch(
				submitEmbeddedSignup(
					{ ...payload, cloud_api_service: cloud_api_service },
					(response: any) => {
						console.log(response, '>>>> from embedded');
						if (response.status == 200) {
							if (response.message != null) {
								Toast(response.message, 'success');
							} else {
								Toast(t('requestExecuted'), 'success');
							}
						} else {
							if (response.message != null) {
								Toast(response.message, 'error');
							} else {
								Toast(t('KLR03100'), 'error');
							}
						}
					}
				)
			);
		} else {
			Toast(t('KLR03102'), 'error');
		}
	};

	return (
		<>
			<FacebookSDK />
			{wabaDataEmpty ? (
				<div>
					{!checkPrivileges('view_only', 'main') && (
						<Button
							small
							iconPosition="left"
							onClick={() =>
								launchWhatsAppSignup(
									whatsappembededsignup(user_pod),
									(response: any, flag: boolean) =>
										handleEmbeddedResponse &&
										handleEmbeddedResponse(response, flag)
								)
							}
							type="secondary"
						>
							{`+`}
							{` `}
							{t('mainAddWabaId')}
						</Button>
					)}
				</div>
			) : (
				<div ref={ref}>
					<Tooltip
						autoAdjustOverflow={false}
						placement="bottom"
						title={
							<div className="text-center">
								<div>{wabaDetails?.business_name}{Number(wabaDetails?.version) === 1 ? " · V1": "" }</div>
								<div>
									{t('mainWaBaId')} - {wabaId}
								</div>
							</div>
						}
						trigger={['hover']}
					>
						<div
							className={Styles.wabaId}
							onClick={() => setShowDropDown((prev) => !prev)}
						>
							<img src={whatsappIcon} />
							<span>{t('mainWaba')}</span>
							<span>{`-`}</span>
							<span className={`${Styles.wabaName}`}>
								{wabaDetails?.business_name}{Number(wabaDetails?.version) === 1 ? " · V1": "" }
							</span>
							<img src={showDropDown ? upArrow : downArrow} />
						</div>
					</Tooltip>
					{showDropDown && (
						<div className={`position-absolute mT8N`}>
							<div className={Styles.dropdown}>
								<div>
									<Alerts
										content={t('wabaIdDropDownBanner')}
										type="draft"
										containerClassName={Styles.wabaWaBanner}
									/>
									<SearchInput
										className={Styles.search}
										eachChar
										label="Search"
										onChange={(e: any) => {
											onSearch(e);
										}}
										placeholder="Search"
									/>
									{!checkPrivileges('view_only', 'main') && (
										<Button
											className={`${Styles.addWabaIdButton}`}
											iconPosition="left"
											onClick={() =>
												launchWhatsAppSignup(
													whatsappembededsignup(
														user_pod
													),
													(
														response: any,
														flag: boolean
													) =>
														handleEmbeddedResponse &&
														handleEmbeddedResponse(
															response,
															flag
														)
												)
											}
											type="tertiary"
										>
											{`+`}
											{` `}
											{t('mainAddWabaId')}
										</Button>
									)}
									{searchedWabaIds?.map((item: any, index: number) => (
										<div
											key={index}
											className={Styles.wabaIdList}
											onClick={() => {
												setShowDropDown(false);
												const currentWabaId = localStorage.getItem(
													'WABA_ID'
												);
												if (
													currentWabaId !=
													item.waba_id
												) {
													if (isLaunchPage) {
														dispatch(
															toggleWabaChangeModal(
																true,
																item.waba_id,
																item.version
															)
														);
													} else {
														setWabaId(item.waba_id);
														setwabaDetails(
															item
														);
														localStorage.setItem(
															'WABA_ID',
															item.waba_id
														);
														dispatch(
															changeWabaIdDropdown(
																item.waba_id,
																item.version
															)
														);
													}
												}
											}}
										>
											<div
												className={`${Styles.wabaListItem}`}
											>
												<div
													className={`${Styles.wabaListName}`}
												>
													{item.business_name}{Number(item.version) === 1 ? " · V1": "" }
												</div>
												<div
													className={`${Styles.wabaListId}`}
												>
													<span>
														{t('mainWaBaId')}
													</span>
													<span>{` - `}</span>
													<span>{item.waba_id}</span>
												</div>
											</div>
										</div>
									))}
								</div>
							</div>
						</div>
					)}
				</div>
			)}
		</>
	);
};

export default memo(WabaId);
